<template>
<v-dialog
    v-model="dialog"
    max-width="920"
    v-if="settings != null"
>
    <v-card>
        <v-card-title>Welcome Screen Settings</v-card-title>

        <v-card-text>

            <b>Provide outside of RedChirp</b><br/>

              <v-switch
                    label="Sign subscription agreement outside of RedChirp"
                    v-model="settings.sign_subscription_agreement_outside_of_redchirp"
                    style="margin-bottom: -20px"
                />

                <v-switch
                    label="Provide payment method outside of RedChirp"
                    v-model="settings.payment_outside_of_redchirp"
                    style="margin-bottom: -20px"
                />

                <v-switch
                    label="Provide general organization information outside RedChirp"
                    v-model="settings.general_setup_outside_redchirp"
                    style="margin-bottom: -20px"
                />

                <v-switch
                    label="Provide website information outside RedChirp"
                    v-model="settings.website_setup_outside_redchirp"
                    style="margin-bottom: -20px"
                />

                <v-switch
                    label="Provide TCR Information outside of RedChirp"
                    v-model="settings.tcr_setup_outside_redchirp"
                    style="margin-bottom: -20px"
                />

               <v-switch
                    label="Setup integrations outside of the welcome screen"
                    v-model="settings.integrations_setup_outside_redchirp"
                    style="margin-bottom: -20px"
                />

        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
            >
            Ok
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            settings: null,
            dialog: false,
        }
    },

    methods: {

        showDialog(profile)
        {
            this.settings = {
                'organization_id': profile.setup_tasks.organization_id,
                'sign_subscription_agreement_outside_of_redchirp': profile.setup_tasks.sign_subscription_agreement_outside_of_redchirp,
                'payment_outside_of_redchirp': profile.setup_tasks.payment_outside_of_redchirp,
                'general_setup_outside_redchirp': profile.setup_tasks.general_setup_outside_redchirp,
                'website_setup_outside_redchirp': profile.setup_tasks.website_setup_outside_redchirp,
                'tcr_setup_outside_redchirp': profile.setup_tasks.tcr_setup_outside_redchirp,
                'integrations_setup_outside_redchirp': profile.setup_tasks.integrations_setup_outside_redchirp
            };

            this.dialog = true;
        },

        onOk()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/welcome/welcome-screen-settings',
            
                'params' : this.settings,
            
                'on_success': (data) => {
                        this.dialog = false;
                        this.$emit('ok', data);
                    },
            
                'on_error': 'Unable to save settings',
            });
        },

        onCancel()
        {
            this.dialog = false;
        },

    },
}
</script>

<style lang="scss" scoped>
</style>